import * as React from 'react'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import styled from 'styled-components'
import {observer} from 'mobx-react'
import {Button} from '../elements/Button'
import {IImageData} from '../types/candidate'
import {LoaderIcon} from '../elements/LoaderIcon'
import {theme} from '../theme'

export interface IModalProps {
  isOpen: boolean
  onSave: () => void
  onClose: () => void
  className?: string
  croppedImageUrl?: string
  src?: string
  crop: Pick<IImageData, 'x' | 'y' | 'width' | 'aspect'>
  onImageLoaded: (image: any) => void
  onCropChange: (image: any) => void
  onCropComplete: (crop: any, pixelCrop: any) => void
  imageUploadIsLoading: boolean
  uploadIsDisabled: boolean
}

@observer
class ImageModalClass extends React.Component<IModalProps> {
  static defaultProps: Pick<IModalProps, 'isOpen'> = {
    isOpen: false
  }

  render() {
    const {
      isOpen,
      onClose,
      onSave,
      className,
      croppedImageUrl,
      src,
      crop,
      onImageLoaded,
      onCropComplete,
      onCropChange,
      imageUploadIsLoading,
      uploadIsDisabled
    } = this.props
    const titleText = !uploadIsDisabled
      ? 'Rajaa kuvaa niin, että se näyttää haluamaltasi vasemmalla olevassa pikkukuvassa.'
      : 'Kuvatiedoston lataus epäonnistui.'
    const descriptionText = !uploadIsDisabled
      ? 'Voit siirtää valittua aluetta klikkaamalla alueen keskeltä. Voit muuttaa valitun alueen kokoa vetämällä kulmista. Varmista, että kasvot ovat kuvan keskellä. Muista tallentaa kuva.'
      : 'Tarkasta tiedostomuoto. Kuvan maksimikoko on 4MB, sallitut tiedostomuodot ovat .jpg, .jpeg ja .png. '

    return isOpen ? (
      <div onClick={onClose} className={className}>
        <ModalContent onClick={e => e.stopPropagation()}>
          <ModalHeaderContainer>
            <CroppedImageContainer>{croppedImageUrl && <img src={croppedImageUrl} />}</CroppedImageContainer>
            <TextContainer removeMargin={uploadIsDisabled}>
              <ModalTitle>{titleText}</ModalTitle>
              <ModalDesktopDescription>{descriptionText}</ModalDesktopDescription>
            </TextContainer>
          </ModalHeaderContainer>
          <ModalMobileDescription>{descriptionText}</ModalMobileDescription>
          {src && (
            <CroppingContainer>
              <ReactCrop src={src} crop={crop} onImageLoaded={onImageLoaded} onComplete={onCropComplete} onChange={onCropChange} />
            </CroppingContainer>
          )}
          <ButtonContainer>
            <Button color={'white'} onClick={onClose} height="40px" fontSize="18px">
              Peruuta
            </Button>
            <Button onClick={onSave} height="40px" fontSize="18px" disabled={uploadIsDisabled}>
              {imageUploadIsLoading && (
                <LoaderSpan>
                  <LoaderIcon />
                </LoaderSpan>
              )}
              <SaveButtonTextSpan isLoading={imageUploadIsLoading}>Tallenna kuva</SaveButtonTextSpan>
            </Button>
          </ButtonContainer>
        </ModalContent>
      </div>
    ) : null
  }
}

const ModalHeaderContainer = styled.div`
  display: flex;
  @media screen and (max-width: 590px) {
    align-items: center;
  }
`

const ModalTitle = styled.h3`
  margin: 0;
`

const ModalContent = styled.div`
  padding: 2rem 3rem;
  background: white;
  width: 90%;
  max-width: 700px;
  height: auto;
  display: flex;
  flex-direction: column;
  margin: 10% auto auto auto;
  border-radius: 4px;
`
const TextContainer = styled.div<{removeMargin: boolean}>`
  ${({removeMargin}) => !removeMargin && 'margin-left: 2rem;'}
`

const ModalDesktopDescription = styled.div`
  margin: 14px 0;
  @media screen and (max-width: 590px) {
    display: none;
  }
`

const ModalMobileDescription = styled.div`
  margin: 14px 0;
  @media screen and (min-width: 591px) {
    display: none;
  }
`

const CroppedImageContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 50%;

  img {
    height: 12.5rem;
    border-radius: 50%;
  }
`

const CroppingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem 0;
  width: 100%;
  height: auto;
  max-height: 90vh;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  > * {
    &:first-child {
      margin-left: 0px;
    }
    &:nth-child(2) {
      margin-left: 2.4rem;
    }
  }
  @media screen and (max-width: ${theme.breakPoints.mobileMax}px) {
    > * {
      &:nth-child(2) {
        margin-left: 3.5vw;
      }
    }
  }
`

export const ImageModal = styled(ImageModalClass)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1000;
  overflow-y: scroll;
  background-color: rgba(0, 0, 0, 0.55);
`

const LoaderSpan = styled.span`
  position: absolute;
  right: 0;
  left: 0;
`

const SaveButtonTextSpan = styled.span<{isLoading: boolean}>`
  ${({isLoading}) => isLoading && 'visibility:hidden;'}
`
